export default class SkinToneEditor {
    constructor() {
        this.defaultValues = {
            range: 5,
            hue: 0,
            saturation: 1,
            luminance: 1,
        };

        this.opacity = {
            minValue: 0,
            maxValue: 100,
        };
    }

    addBlock(blockNum = lutify.blocks.length, controlSelected = "hue_hue") {
        UI.createAdjustmentBlockTemplate("skin-tone-editor", blockNum);
        let element = UI.getAdjustmentBlock(blockNum);

        $(element).find(".expand_options").trigger("click", [false]);
        $(element).find(".opacity_slider").on("input", () => this.opacitySliderHandler($(element)));
        $(element).find(".opacity-input").on("change", () => this.opacityInputHandler($(element)));

        $(element).find(".range_slider:not(.opacity_slider)").on("input", e => {
            blocks.checkSwitchHandler($(element));
            this.sliderHandler($(e.currentTarget));
        });

        $(element).find(".range_value:not(.opacity-input)").on("change", e => {
            blocks.checkSwitchHandler($(element));
            this.sliderHandler($(e.currentTarget));
        });

        UI.initKnob(element, {
            size: 30,
        });

        blocks.add({
            name: "SkinToneEditor",
            passes: this.addPasses(),
            blockNum,
            blendingMode: 0,
            blendingModeName: "Normal",
            opacity: 100,
            values: {
                range: 5,
                hue: 0,
                saturation: 1,
                luminance: 1,
            },
        });
    }

    addPasses() {
        const pass = gpu.createHueSaturationShaderPass({
            BASE_WEIGHTS_RED: 0.2,
            RANGE_DEGREE: 72.0
        });

        gpu.addPassToComposer(pass, "toMiddle");

        return [pass];
    }

    sliderHandler($element) {
        let value = parseFloat($element.val());
        let color = $element.data("range");
        let subControl = $element.closest(".block-sliders-container").data("sub-control");

        if ($element.hasClass("range_value")) {
            if (value > parseInt($element.attr("max"))) {
                value = parseInt($element.attr("max"));
                $element.val(value);
            }
            if (value < parseInt($element.attr("min"))) {
                value = parseInt($element.attr("min"));
                $element.val(value);
            }
        }

        if ($element.hasClass("range_slider"))
            $element
                .closest(".block-sliders-container")
                .find(".range_value")
                .val(value);
        else $element
            .closest(".block-sliders-container")
            .find(".range_slider")
            .val(value);

        // lutify.getActiveBlock().color = value;
        lutify.getActiveBlock().values[subControl] = value;

        if (subControl == "range") this.callGPURange(360 / value, color);
        else if (subControl == "hue") this.callGPUHue(value / 180.0, color);
        else if (subControl == "saturation") this.callGPUSaturation(value - 1 > 0 ? (value - 1) * 0.6 : value - 1, color);
        else if (subControl == "luminance") this.callGPULuminance(value - 1, color);
    }

    callGPURange(value, color) {
        lutify.getActiveBlock().passes[0].enabled = true;
        lutify.getActiveBlock().passes[0].uniforms['rangeDegree'].value = value;
        gpu.render();
    }

    callGPUHue(value, color) {
        lutify.getActiveBlock().passes[0].enabled = true;
        lutify.getActiveBlock().passes[0].uniforms["hue" + color].value = value;
        gpu.render();
    }

    callGPUSaturation(value, color) {
        lutify.getActiveBlock().passes[0].enabled = true;
        lutify.getActiveBlock().passes[0].uniforms["sat" + color].value = value;
        gpu.render();
    }

    callGPULuminance(value, color) {
        lutify.getActiveBlock().passes[0].enabled = true;
        lutify.getActiveBlock().passes[0].uniforms["lum" + color].value = value;
        gpu.render();
    }

    opacitySliderHandler($element) {
        let opacityValue = $element.find(".opacity_slider").val();
        let calcOpacityValue = opacityValue * 0.01;

        $element.find(".opacity-input").val(opacityValue);

        lutify.getActiveBlock().opacity = opacityValue;
        lutify.getActiveBlock().passes.forEach(pass => {
            pass.uniforms.opacity.value = calcOpacityValue;
        })

        gpu.render();
    }

    opacityInputHandler($element) {
        let opacityValue = $element.find(".opacity-input").val();
        let opacitySlider = $element.find(".opacity_slider");

        if (opacityValue > this.opacity.maxValue) opacityValue = this.opacity.maxValue;
        if (opacityValue < this.opacity.minValue) opacityValue = this.opacity.minValue;

        opacitySlider.val(opacityValue);
        opacitySlider.trigger("input");
    }

    applyChanges($block, values, blockData) {
        Object.keys(values).forEach(control => {
            let slider = $block.find(`.block-sliders-container[data-sub-control="${control}"] > .range_slider`);
            slider.val(values[control]);
            slider.trigger("input");
        });

        if ('opacity' in blockData) {
            $block.find(".opacity-input").val(parseInt(blockData.opacity));
            $block.find(".opacity-input").trigger("change");
        }
    }
}
